<template>
  <div>

    <base-form :title="$route.params.id ? $t('generic.details') : $t('routes.titles.clientsCreate')"
               :loading="loading"
               @submit="submitForm">
      <div class="row d-flex">
        <div class="px-4 pt-5">
          <image-upload @on-change="onImageChange"
                        :src="clientToEdit.image">
          </image-upload>
        </div>
        <div class="col-12 col-sm-8 col-md-7 col-xl-8">
          <div class="row">
            <div class="col-12">
              <fg-input :placeholder="$t('client.management.edit.name')"
                        :name="$t('client.management.edit.name')"
                        :error="getError($t('client.management.edit.name'))"
                        :label="$t('client.management.edit.name')"
                        v-validate="modelValidations.name"
                        v-model="clientToEdit.name">
              </fg-input>
            </div>
            <div class="col-12">
              <fg-input :error="getError($t('client.management.edit.status'))"
                        :label="$t('client.management.edit.status')">
                <el-select class="select-default"
                           :name="$t('client.management.edit.status')"
                           :placeholder="$t('client.management.edit.status')"
                           :error="getError($t('client.management.edit.status'))"
                           v-validate="modelValidations.status"
                           v-model="clientToEdit.status"
                           filterable
                           clearable>
                  <el-option class="select-default"
                             v-for="option in clientStatuses"
                             :value="option.value"
                             :label="option.label"
                             :key="option.value">
                  </el-option>
                </el-select>
              </fg-input>
            </div>
            <div class="col-12 ">
              <fg-input :error="getError($t('client.management.edit.type'))"
                        :label="$t('client.management.edit.type')">
                <el-select class="select-default"
                           :name="$t('client.management.edit.type')"
                           :placeholder="$t('client.management.edit.type')"
                           :error="getError($t('client.management.edit.type'))"
                           v-validate="modelValidations.type"
                           v-model="clientToEdit.type"
                           filterable
                           clearable>
                  <el-option class="select-default"
                             v-for="option in clientTypes"
                             :value="option.value"
                             :label="option.label"
                             :key="option.value">
                  </el-option>
                </el-select>
              </fg-input>
            </div>
          </div>
        </div>
      </div>
    </base-form>
    <addresses-list v-if="$route.params.id" primary-entity="client"/>
    <phone-list v-if="$route.params.id" primary-entity="client"/>

  </div>
</template>
<script>
  import { Select, Option } from 'element-ui';
  import AddressesList from 'src/views/admin/contacts/common/AddressesList'
  import PhoneList from 'src/views/admin/contacts/common/PhonesList'
  import InvoiceStrategySelect from 'src/components/Autocomplete/InvoiceStrategySelect'
  import ImageUpload from 'src/components/ImageUpload';
  import BaseAvatar from 'src/components/BaseAvatar';
  import { clientStatus, clientType } from "src/config/clientEnums";

  export default {
    name: 'client-form',
    components: {
      PhoneList,
      BaseAvatar,
      ImageUpload,
      AddressesList,
      InvoiceStrategySelect,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      client: {
        type: Object,
        default: () => ({})
      },
      action: {
        type: Function,
        default: () => {
        },
        required: true
      },
      mode: {
        type: String,
        default: 'edit'
      }
    },
    data() {
      return {
        clientToEdit: {
          name: '',
          status: '',
          type: '',
          image: '',
        },
        loading: false
      }
    },
    computed: {
      currencySymbol() {
        return this.$store.state.config.currencySymbol
      },
      clientStatuses() {
        return Object.keys(clientStatus).map(key => {
          let value = clientStatus[key];
          return {
            label: this.$t(`generic.clientStatuses.${value}`),
            value
          }
        });
      },
      clientTypes() {
        return Object.keys(clientType).map(key => {
          let value = clientType[key];
          return {
            label: this.$t(`generic.clientTypes.${value}`),
            value
          }
        });
      },
      modelValidations() {
        return {
          name: {
            required: true,
            min: 2
          },
          status: {
            required: true,
            min: 2
          },
          type: {
            required: true,
            min: 2
          },
        }
      }
    },
    methods: {
      onImageChange(src) {
        this.clientToEdit.image = src;
      },
      async validate() {
        return this.$validator.validateAll();
      },
      async submitForm() {
        let result = await this.validate();
        if (!result) return;
        let data = {
          ...this.clientToEdit
        };
        try {
          this.loading = true
          await this.action(this.clientToEdit.uuid, data);
        } catch (e) {
          console.warn(e)
        } finally {
          this.loading = false
        }
      }
    },
    created() {
      this.$watch('client', newVal => {
        if (this.mode === 'add' || !newVal) {
          return;
        }
        this.clientToEdit = JSON.parse(JSON.stringify(newVal));

      }, { immediate: true });
    }
  }
</script>
<style lang="scss">
  .client-form__row {
    display: flex;
    flex-wrap: wrap;

    .image-wrapper {
      width: 200px;
      display: flex;
      padding-left: 25px;
    }
    .form-wrapper {
      flex: 1;
      padding: 0 25px
    }
  }
</style>
